export const state = {
    services: []
};

export const getters = {
    services(state) {
        return state.services.map((service, index) => {
            service.order = service.order || index + 1;
            return service;
        });
    },
    total(state) {
        return state.services.reduce((total, item) => total + parseFloat(item.service.reste_a_paye), 0).toFixed(2);
    }
};

export const mutations = {
    add(state, service) {
        state.services.push(service);
    },
    remove(state, { eleve_id, service_id, mois_id }) {
        state.services = state.services.filter(item => !(item.eleve.id == eleve_id && item.service.id == service_id && item.service.mois_id == mois_id));
    },
    clear(state) {
        state.services = [];
    },
    reorder(state, { index, direction, montant }) {
        let services = [...state.services];

        if (direction == "up") {
            services = services.map((item, i) => {
                if (i == index) item.order--;
                else if (i == index - 1) item.order++;
                return item;
            });
        } else if (direction == "down") {
            services = services.map((item, i) => {
                if (i == index) item.order++;
                else if (i == index + 1) item.order--;
                return item;
            });
        }

        if (montant) {
            let total = 0;
            for (let i = 0; i < services.length; i++) {
                let item = services[i];
                total += parseFloat(item.service.reste_a_paye);
                if (total <= montant) {
                    item.counted = true;
                    item.reste = 0;
                    item.ignore = false;
                    if (total == montant) {
                        services.filter((_, index) => index > i).forEach(item => (item.ignore = true));
                        break;
                    }
                } else {
                    item.counted = true;
                    item.reste = (total - montant).toFixed(2);
                    item.ignore = false;
                    services.filter((_, index) => index > i).forEach(item => (item.ignore = true));
                    break;
                }
            }
        }

        state.services = services.sort((a, b) => a.order - b.order);
    }
};

export const actions = {
    add({ commit }, service) {
        commit("add", service);
    },
    remove({ commit }, payload) {
        commit("remove", payload);
    },
    clear({ commit }) {
        commit("clear");
    },
    reorder({ commit }, payload) {
        commit("reorder", payload);
    }
};
